// import '@nextore/common';
import { apiModule } from '@nextore/core';
import '@nextore/modules';
import { container, Plugin as VContainer } from '@unify/v-container';
import { Plugin as VMVCPlugin } from '@unify/v-mvc';
import { buildProviderModule } from 'inversify-binding-decorators';
import Vue from 'vue';

container.load(apiModule());
container.load(buildProviderModule());

Vue.use(VContainer);
Vue.use(VMVCPlugin);
